<script setup>
import utils from '@/utils'

definePageMeta({
  middleware(to, from) {
    const { params, query } = to
    console.log(params.id, query)
    if (/(\d+)-(\d+)/gi.test(params.id)) {
      const regex = /(\d+)-(\d+)/gi
      const matches = regex.exec(params.id)
      const queryStr = utils.getQueryString(query)
      if (matches.length === 3 && matches[1] !== undefined && matches[2] !== undefined) {
        return navigateTo(301, `/regions/${matches[1]}/categories/${matches[2]}${queryStr}`, { replace: true })
      }
    }
    throw showError({ statusCode: 404, message: 'Post not found', fatal: true })
  },
})
</script>
